import { create } from "zustand";

interface TabStore {
  selectedTab: "calendar" | "list" | null;
  count: number;
  setCount: (count: number) => void;
  setSelectedTab: (tab: "calendar" | "list") => void;
}

const useTabStore = create<TabStore>((set) => ({
  count: 0,
  setCount: (count) => set(() => ({ count })),
  selectedTab: null,
  setSelectedTab: (tab) => set(() => ({ selectedTab: tab })),
}));

export default useTabStore;
